



























import { Component, Prop, Vue } from 'vue-property-decorator'

import AppCarouselScroll from '@/components/AppCarouselScroll.vue'
import AppSectionTileItem from '@/components/AppSectionTileItem.vue'

@Component({
  components: {
    AppCarouselScroll,
    AppSectionTileItem
  }
})
export default class extends Vue {
  @Prop(Object) readonly option!: object
  @Prop(Array) readonly categoryToItems!: {
    id: string;
    items: object[];
    category: {
      name: string;
    };
  }[]

  idSelected = ''

  mounted () {
    this.idSelected = this.categoryToItems[0].id
    this.$emit('click-category', this.categoryToItems[0].category.name)
  }

  get itemsDict () {
    return this.categoryToItems.reduce((acc: { [key: string]: object[] }, cur) => {
      acc[cur.id] = cur.items
      return acc
    }, {})
  }
}
